import styled from '@emotion/styled';

export default styled.div`
    position: relative;
    width: 100%;
    min-height: 30vh;
    overflow: hidden;
`;